import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    }
}));

export default function SearchOption(props) {
    const classes = useStyles();
    function getStyle() {
        var height = 0;
        if(props.isMobileMode){
            if(props.showHeader){
                height = 50;
            }else{
                height = 0;
            }
        }else{
            if(props.showHeader){
                height = 80;
            }else{
                height = 30;
            }
        }

        return {
            width: props.width > 400 ? "400px" : props.width + "px",
            height:  "calc(100% - " + height + "px)"
        };
    }

    return (
        <div className="option-panel" style={getStyle()}>
            <div role="main" className="option-flex">
                <div className="option-header">
                    <div className="option-header-buttons">
                        <button aria-label="戻る"
                            className="option-header-back-button"
                            onClick={props.onBack}
                        >
                            <i className="bi bi-arrow-left"></i>
                        </button>
                    </div>
                    <div className="option-header-title">
                        <span>オプション</span>
                    </div>
                </div>
                <div className="option-content">
                    <FormControl className={classes.formControl}>
                        <InputLabel id="maxCountLabel">検索件数</InputLabel>
                        {props.viewtype === "jice" ?
                            <Select
                                labelId="maxCountLabel"
                                value={props.maxCount}
                                onChange={(event)=>props.onChangeMaxCount(event.target.value)}
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                                <MenuItem value={1000}>1000</MenuItem>
                                {/* <MenuItem value={2000}>2000</MenuItem>
                                <MenuItem value={5000}>5000</MenuItem>
                                <MenuItem value={10000}>10000</MenuItem> */}
                            </Select>
                            :
                            <Select
                                labelId="maxCountLabel"
                                value={props.maxCount}
                                onChange={(event)=>props.onChangeMaxCount(event.target.value)}
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                            </Select>
                        }
                        
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.searchOnIdle}
                                    onChange={(event)=>props.onChangeSearchOnIdle(event.target.checked)}
                                    color="primary"
                                />
                            }
                            label="地図の移動後に結果を更新する"
                        />
                    </FormControl>
                </div>
            </div>
        </div>
    );

}